import React, { useContext, useEffect, useState } from 'react';
import {NavLink} from "react-router-dom";
// import navbarData from '../../data/navbar'
// import CountryController from '../../controllers/country';
import { GlobalContext } from "../../handlers/GlobalContext";


class NavItem extends React.Component {
    constructor(props){
        super(props);

        this.setLocale = this.setLocale.bind(this);
        this.translate = this.translate.bind(this);

        this.state = {}
        this.controllers = {}
    }

    setLocale = (countryid) => {
        this.context[1]({ type: 'SET_LOCALE', payload: { countryid: countryid } });
    }

    translate = (term, alt) => {
        return this.context[0].locale.translation[term] || alt || term;
    }

    render(){
        return (
            this.context[0].menu.map(navItem => {
                if(!navItem.enabled || (!navItem.public && !this.context[0].authenticated)) return(null);

                if(!!navItem.localisation)
                    return(
                        <li key={navItem.id} className={!!navItem.subMenu ? 'menu-item-has-children localisation-item' : null}>
                            <NavLink
                                onClick={(e) => {e.preventDefault()}}
                                exact={navItem.link === `/`}
                                to={`${null}`}
                                activeClassName={'active'} className={(!!navItem.button ? 'item-button' : null)}>
                                <i className={"fa fa-globe"}/>
                                <span>{this.context[0].locale.locale.lang}</span>
                            </NavLink>


                            {navItem.subMenu ? (
                                <ul className="sub-menu">
                                    {navItem.subMenu.map(subItem => (
                                        <li key={subItem.id}
                                            className={subItem.subMenu ? "menu-item-has-children localisation-item" : "localisation-item"}>
                                            <NavLink onClick={(e) => {e.preventDefault(); this.setLocale(subItem.countryId);}} to={`${null}`}>{subItem.lang + " - " + this.translate(subItem.element, subItem.title) }</NavLink>
                                        </li>
                                    ))}
                                </ul>
                            ) : null}
                        </li>
                    );

                return(
                    <li key={navItem.id} className={!!navItem.subMenu ? 'menu-item-has-children' : null}>
                        <NavLink
                            exact={navItem.link === `/`}
                            to={`${process.env.PUBLIC_URL + navItem.link}`}
                            activeClassName={'active'} className={(!!navItem.button ? 'item-button' : null)}>
                            { this.translate(navItem.element, navItem.title) }
                        </NavLink>


                        {navItem.subMenu ? (
                            <ul className="sub-menu">
                                {navItem.subMenu.map(subItem => (
                                    <li key={subItem.id}
                                        className={subItem.subMenu ? "menu-item-has-children" : null}>
                                        <NavLink to={`${process.env.PUBLIC_URL + subItem.link}`}>{subItem.title}</NavLink>


                                        {subItem.subMenu ? (
                                            <ul className="sub-menu">
                                                {subItem.subMenu.map(dropSubItem => (
                                                    <li key={dropSubItem.id}>
                                                        <NavLink to={`${process.env.PUBLIC_URL + dropSubItem.link}`}>
                                                            {dropSubItem.title}
                                                        </NavLink>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : null}
                                    </li>
                                ))}
                            </ul>
                        ) : null}
                    </li>
                )
            })
        );
    }
}

// const NavItem2 = () => {
//     const [ state, dispatch] = useContext(GlobalContext);
//     const [ locale, setLocale ] = useState(7);
//     const [ load, setLoad ] = useState(false);
//     const [ nbarList, setNbarList ] = useState(navbarData)
//
//     const countryController = new CountryController();
//
//     useEffect(()=>{
//         if(!!load) return;
//
//         countryController.getLocales()
//             .then((localeList) => {
//                 var fLocaleList = localeList.map((lLocale) => {
//                     return({
//                         id: (6+(lLocale.countryId/10)),
//                         title: lLocale.longName,
//                         code: lLocale.code,
//                         countryId: lLocale.countryId
//                     })
//                 })
//
//                 setNbarList(navbarData.concat({
//                     "id": 6,
//                     "title": "Serbia",
//                     "code": "SRB",
//                     "flag": "srb.png",
//                     "megaMenu": false,
//                     "subMenu": [
//                         {
//                             "id": 6.1,
//                             "title": "Serbia",
//                             "countryId": 4
//                         }
//                     ],
//                     "public": false,
//                     "localisation": true
//                 }))
//
//                 //if(!!navbarData[navbarData.length - 1].subMenu) navbarData[navbarData.length - 1].subMenu = fLocaleList;
//                 console.log(localeList)
//                 console.log(fLocaleList)
//             })
//
//         // dispatch({ type: 'GET_LOCALE_OPTIONS' })
//         //     .then((lState) => {
//         //         console.log(lState);
//         //         console.log(state);
//         //     })
//
//         //TODO: load the countries from database in the Reducer (GlobalContext) and assign the prefered one as active
//         //TODO: loaded list to be formated as last item in the menu that has child (see example in navbar/index.json)
//
//         setLoad(true);
//         console.log("asdasdasd")
//     },[load, state])
//
//     useEffect(()=>{
//         console.log(locale);
//
//         //dispatch({ type: 'SET_LOCALE', payload: { countryid: locale } })
//
//         //TODO: On change of locale, in the Reducer change global locale and reload the page (in case of medical products, redirect to the list of all and reset the search!)
//         //TODO: update the current list of menu items so that the last one is updated with the new CODE and optionally FLAG!
//
//     },[locale])
//
//     return (
//         nbarList.map(navItem => {
//             if(!navItem.public && !state.authenticated) return(null);
//
//             if(!!navItem.localisation)
//                 return(
//                     <li key={navItem.id} className={!!navItem.subMenu ? 'menu-item-has-children localisation-item' : null}>
//                         {/*<a href={null}>*/}
//                             {/*{navItem.title}*/}
//                         {/*</a>*/}
//                         <NavLink
//                             onClick={(e) => {e.preventDefault()}}
//                             exact={navItem.link === `/`}
//                             to={`${null}`}
//                             activeClassName={'active'} className={(!!navItem.button ? 'item-button' : null)}>
//                             {navItem.code}
//                             {/*<img src={localisationData[navItem.code].flag} /> { navItem.title }*/}
//                         </NavLink>
//
//
//                         {navItem.subMenu ? (
//                             <ul className="sub-menu">
//                                 {navItem.subMenu.map(subItem => (
//                                     <li key={subItem.id}
//                                         className={subItem.subMenu ? "menu-item-has-children localisation-item" : "localisation-item"}>
//                                         <NavLink onClick={(e) => {e.preventDefault(); setLocale(subItem.countryId);}} to={`${null}`}>{subItem.title}</NavLink>
//                                     </li>
//                                 ))}
//                             </ul>
//                         ) : null}
//                     </li>
//                 );
//
//             return(
//                 <li key={navItem.id} className={!!navItem.subMenu ? 'menu-item-has-children' : null}>
//                     <NavLink
//                         exact={navItem.link === `/`}
//                         to={`${process.env.PUBLIC_URL + navItem.link}`}
//                         activeClassName={'active'} className={(!!navItem.button ? 'item-button' : null)}>
//                         {navItem.title}
//                     </NavLink>
//
//
//                     {navItem.subMenu ? (
//                         <ul className="sub-menu">
//                             {navItem.subMenu.map(subItem => (
//                                 <li key={subItem.id}
//                                     className={subItem.subMenu ? "menu-item-has-children" : null}>
//                                     <NavLink to={`${process.env.PUBLIC_URL + subItem.link}`}>{subItem.title}</NavLink>
//
//
//                                     {subItem.subMenu ? (
//                                         <ul className="sub-menu">
//                                             {subItem.subMenu.map(dropSubItem => (
//                                                 <li key={dropSubItem.id}>
//                                                     <NavLink to={`${process.env.PUBLIC_URL + dropSubItem.link}`}>
//                                                         {dropSubItem.title}
//                                                     </NavLink>
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     ) : null}
//                                 </li>
//                             ))}
//                         </ul>
//                     ) : null}
//                 </li>
//             )
//         })
//     );
// };

NavItem.contextType = GlobalContext;
export default NavItem;
